import {Component, createRef} from 'react';
import TimeAgo from 'timeago-react';
import classes from './archivestyles.module.css';

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

const Item = (props) => {
    var selected = props.selectedArchive === props.conversationID ? true : false;
    var name = props.patientName !== undefined ? capitalize(props.patientName) : 'Patient';
    var email = props.patientEmail !== undefined ? `(${props.patientEmail})` : '';
    return (
        <div className={selected ? classes.selected_list_view : classes.arc_list_view}
             onClick={() => props.onArchiveItemClick(props.archiveData)}>
            <div className={classes.list_img_style}>
                <div className={classes.selected_list_img}>
                    <span className={classes.selected_user_img}>{name.charAt(0)}</span>
                </div>
            </div>
            <div className={classes.list_item}>
                <div className={selected ? classes.selected_item_name : classes.patient_name}>{name}</div>
                {/* <div className={selected ? classes.selected_item_name : classes.item_name}>{email}</div> */}
                <div className={selected ? classes.selected_item_name : classes.item_name}>{props.doctorName}</div>
                {/* <div className={selected ? classes.selected_item_name : classes.item_name}><span>{name.charAt(0)}: </span>
                    Hello Doctor!
                    My name is {props.patientName}.</div> */}

            </div>
            {!selected &&
            <div className={classes.list_item_second}>
                <div>
                    <div className={classes.time_style}><TimeAgo datetime={props.timestamp}/></div>
                </div>
            </div>
            }
        </div>
    )
}

export default class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedArchive: null,
            archiveSetState: 0
        }
    }

    componentDidMount() {
        // this.props.selectArchive('')
    }

    onArchiveItemClick = (data) => {

        const {
            user_id, patientEmail, patientName, doctorName, doctorID, patientID, doctorImage,
            conversationID, tagsList, city, country, platform, DOB, gender, issue, currentMedications,
            diagnosisValue, opinionDescriptionValue, commentAdded, medications, followUpData,
            gmtOffset, buildNumber, convoCount, averageSleep, currentSleep, heartRate, heightCm, heightFeet,
            stepCount, runningWalking, weightKg, weightLbs, periodStartDate, flowType, restingHeartRate,
            complete_address, timestamp, issueResolved,
            symptoms, findings, assessment, plan, icd, billing_code, billing_unit,
            prescriptions, requisitions, special_referals, video_consult, followUpDays
        } = data;

        this.setState({selectedArchive: conversationID});
        // this.props.selectArchive(conversationID)
        this.props.archiveHeaderItem(user_id, patientEmail, patientName, doctorName, doctorID, patientID, doctorImage,
            conversationID, tagsList, city, country, platform, DOB, gender, issue, currentMedications,
            diagnosisValue, opinionDescriptionValue, commentAdded, medications, followUpData,
            gmtOffset, buildNumber, convoCount, averageSleep, currentSleep, heartRate, heightCm, heightFeet,
            stepCount, runningWalking, weightKg, weightLbs, periodStartDate, flowType, restingHeartRate,
            complete_address, timestamp, issueResolved,
            symptoms, findings, assessment, plan, icd, billing_code, billing_unit,
            prescriptions, requisitions, special_referals, video_consult, followUpDays, data);
    }

    archiveDefault = () => {
        if (this.props.archives[0]) {
            const {
                user_id,
                patientEmail,
                patientName,
                doctorName,
                doctorID,
                patientID,
                doctorImage,
                conversationID,
                tagsList,
                city,
                country,
                platform,
                DOB,
                gender,
                issue,
                currentMedications,
                diagnosisValue,
                opinionDescriptionValue,
                commentAdded,
                medications,
                followUpData,
                gmtOffset,
                buildNumber,
                convoCount,
                averageSleep,
                currentSleep,
                heartRate,
                heightCm,
                heightFeet,
                stepCount,
                runningWalking,
                weightKg,
                weightLbs,
                periodStartDate,
                flowType,
                restingHeartRate,
                complete_address,
                timestamp,
                issueResolved,
                symptoms,
                findings,
                assessment,
                plan,
                icd,
                billing_code,
                billing_unit,
                prescriptions,
                requisitions,
                special_referals,
                video_consult,
                followUpDays
            } = this.props.archives[0];

            this.setState({selectedArchive: conversationID});
            // this.props.selectArchive(conversationID)
            this.props.archiveHeaderItem(user_id, patientEmail, patientName, doctorName, doctorID, patientID, doctorImage,
                conversationID, tagsList, city, country, platform, DOB, gender, issue, currentMedications,
                diagnosisValue, opinionDescriptionValue, commentAdded, medications, followUpData,
                gmtOffset, buildNumber, convoCount, averageSleep, currentSleep, heartRate, heightCm,
                heightFeet, stepCount, runningWalking, weightKg, weightLbs, periodStartDate, flowType,
                restingHeartRate, complete_address, timestamp, issueResolved,
                symptoms, findings, assessment, plan, icd, billing_code, billing_unit,
                prescriptions, requisitions, special_referals, video_consult, followUpDays, this.props.archives[0]);
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (Boolean(newProps.archives) && Boolean(newProps.archives[0]) && this.state.archiveSetState !== 1) {
            const {
                user_id,
                patientEmail,
                patientName,
                doctorName,
                doctorID,
                patientID,
                doctorImage,
                conversationID,
                tagsList,
                city,
                country,
                platform,
                DOB,
                gender,
                issue,
                currentMedications,
                diagnosisValue,
                opinionDescriptionValue,
                commentAdded,
                medications,
                followUpData,
                gmtOffset,
                buildNumber,
                convoCount,
                averageSleep,
                currentSleep,
                heartRate,
                heightCm,
                heightFeet,
                stepCount,
                runningWalking,
                weightKg,
                weightLbs,
                periodStartDate,
                flowType,
                restingHeartRate,
                complete_address,
                timestamp,
                issueResolved,
                symptoms,
                findings,
                assessment,
                plan,
                icd,
                billing_code,
                billing_unit,
                prescriptions,
                requisitions,
                special_referals,
                video_consult,
                followUpDays
            } = newProps.archives[0];

            this.setState({selectedArchive: newProps.archives[0].conversationID, archiveSetState: 1});
            // this.props.selectArchive(newProps.archives[0].conversationID)

            this.props.archiveHeaderItem(user_id, patientEmail, patientName, doctorName, doctorID, patientID, doctorImage,
                conversationID, tagsList, city, country, platform, DOB, gender, issue, currentMedications,
                diagnosisValue, opinionDescriptionValue, commentAdded, medications, followUpData,
                gmtOffset, buildNumber, convoCount, averageSleep, currentSleep, heartRate, heightCm,
                heightFeet, stepCount, runningWalking, weightKg, weightLbs, periodStartDate, flowType,
                restingHeartRate, complete_address, timestamp, issueResolved,
                symptoms, findings, assessment, plan, icd, billing_code, billing_unit,
                prescriptions, requisitions, special_referals, video_consult, followUpDays, newProps.archives[0]);
        }
    }

    componentDidUpdate() {
        if (Boolean(this.props.previous_length) && !this.props.isSearch) {
            if (this.props.previous_length !== this.props.archives.length - 1 && Boolean(this[`myrefRow ${this.props.previous_length}`].current))
                this[`myrefRow ${this.props.previous_length}`].current.scrollIntoView({block: "start"});
        }
    }

    archiveSearchValue = (event) => {
        this.props.archiveSearchValue(event.target.value);
    }
    archiveSearchText = (event) => {
        this.props.archiveSearchText();
    }

    render() {
        var archivesList = [];
        if (Boolean(this.props.archives)) {
            archivesList = this.props.archives.map((archive, index) => {
                let ref = `myrefRow ${index}`;
                this[ref] = createRef();

                return <Item
                    key={archive.conversationID}
                    patientName={archive.patientName}
                    doctorName={archive.doctorName}
                    conversationID={archive.conversationID}
                    doctorImage={archive.doctorProfileImg}
                    doctorID={archive.doctorID}
                    timestamp={archive.timestamp}
                    archiveData={archive}
                    patientEmail={archive.patientEmail}
                    tagsList={archive.tagsList !== undefined ? archive.tagsList : []}
                    onArchiveItemClick={(data) => this.onArchiveItemClick(data)}
                    selectedArchive={this.state.selectedArchive}
                    nextref={this[ref]}
                />
            })
        }

        return (
            <div className={classes.list_view}>
                <div className={classes.block}>
                    <div className={classes.block}>
                        <div className={classes.main_block}>
                            <div className={classes.list_body_view}>
                                <div className={classes.list_body_main}>

                                    <div className={classes.search_box}>
                                        <div className={classes.search_box_section}>
                                            <div className={classes.input_view}>
                                                <input
                                                    placeholder="Press enter to search in archives"
                                                    className={classes.input_style}
                                                    onChange={(event) => this.archiveSearchValue(event)}
                                                    onKeyPress={event => {
                                                        if (event.key === 'Enter') {
                                                            this.props.archiveSearchText(event)
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className={classes.search_sub_section}>
                                                <div className={classes.list_count}>
                                                    {Boolean(this.props.archives) &&
                                                    <div><span>{this.props.archives.length} </span>chats</div>
                                                    }
                                                </div>
                                                <div className={classes.search_button} onClick={event => {
                                                    this.props.archiveSearchText(event)
                                                }}> Search
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {!this.props.loading && Boolean(this.props.archives) && this.props.archives.length !== 0 &&
                                    <div className={classes.ul_list}>
                                        {archivesList}
                                        {!this.props.isSearch && !this.props.isLast &&
                                        <div className={classes.load_more} onClick={() => this.props.nextArchives()}>
                                            Load More
                                        </div>
                                        }
                                    </div>
                                    }
                                    {!this.props.loading && this.props.archives.length === 0 &&
                                    <div className={classes.no_text}>No data is found</div>
                                    }

                                    {this.props.loading &&
                                    <div className={classes.no_loading}>
                                        <div className={classes.no_loading_view}>
                                            <div className={classes.loading_loader}/>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
